import React from "react";
import { FaTrophy } from "react-icons/fa";
import "../CSS/Awards.css";
import { Carousel } from "react-bootstrap";
import img1 from "../Images/Awards/1.jpeg";
import img2 from "../Images/Awards/2.jpeg";
import img3 from "../Images/Awards/3.jpeg";
import img4 from "../Images/Awards/4.jpeg";
import img5 from "../Images/Awards/5.jpeg";
import img6 from "../Images/Awards/6.jpeg";
import img7 from "../Images/Awards/7.jpeg";
import img8 from "../Images/Awards/8.jpeg";
import img9 from "../Images/Awards/9.jpeg";
import img10 from "../Images/Awards/10.jpeg";
import img11 from "../Images/Awards/11.jpeg";
import img12 from "../Images/Awards/12.jpeg";
import img13 from "../Images/Awards/13.jpeg";
import img14 from "../Images/Awards/14.jpeg";
import img15 from "../Images/Awards/15.jpeg";
import img16 from "../Images/Awards/16.jpeg";
import img17 from "../Images/Awards/17.jpeg";
import img18 from "../Images/Awards/18.jpeg";


// const bestawards = [
//   {
//     text: "Winner – SIP Champion 2024 (North India) | Awarded by Moneycontrol – Mutual Fund Summit",
//   },
//   {
//     text: "CNBC TV18 Award – Best Performing Financial Advisor in Tier II Cities (North) 2018-2019",
//   },
//   {
//     text: "NSE Regional Individual Financial Advisory Award",
//   },
//   {
//     text: "CNBC TV18, UTI MF & ICRA Award 2015",
//   },
// ];

const Awards = () => {
    const awards = [
        {
          id: 1,
          image: img1,
          title: "1",
          description: "Awarded by Moneycontrol at Mutual Fund Summit"
        },
        {
          id: 2,
          image: img2,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 3,
          image: img3,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 4,
          image: img4,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 5,
          image: img5,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 6,
          image: img6,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 7,
          image: img7,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 8,
          image: img8,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 9,
          image: img9,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 10,
          image: img10,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 11,
          image:img11,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 12,
          image: img12,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 13,
          image: img13,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 14,
          image: img14,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 15,
          image: img15,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 16,
          image: img16,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 17,
          image: img17,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
        {
          id: 18,
          image: img18,
          title: "Best Performing Advisor",
          description: "CNBC TV18, Tier II Cities (2018-2019)"
        },
       
      ];
      
  return (
    <section className="awards-section">
      <div className="awards-text">
        <h2 className="d-flex justify-content-center align-items-center">Awards & Recognition</h2>
        {/* <p>
          At MF Today, we take pride in delivering trusted investment solutions that make a difference. 
          Our commitment to financial excellence has earned us several prestigious accolades, including:
        </p> */}

        {/* <ul className="award-list" textAlign="left">
          {bestawards.map((award, index) => (
            <li key={index}>
              <FaTrophy className="award-icon" textAlign="left"/>
              <p textAlign="left">{award.text}</p>
            </li>
          ))}
        </ul> */}

        
      <div className="awards-image">

        <Carousel>
            {awards.map((award) => (
                <Carousel.Item key={award.id}>
                <img
                    className="d-block mx-auto"
                    src={award.image}
                    alt={award.title}
                    style={{
                        height: '600px',
                        width: '100%',
                        objectFit: 'contain',
                        backgroundColor: '#f8f8f8', // Optional: fills space around the image
                        padding: '10px', // Optional: avoid image touching edges
                      }}
                />
                <div className="carousel-caption d-none d-md-block">
                    {/* <h3>{award.title}</h3> */}
                    {/* <p>{award.description}</p> */}
                </div>
                </Carousel.Item>
            ))}

        </Carousel>
      </div>
      <p className="closing-line d-flex justify-content-center align-items-center">
          Join thousands of investors who trust us for their financial success.
        </p>
      </div>

    </section>
  );
};

export default Awards;
